import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { underscore } from '@ember/string';
import ContactModel from 'donor-elf-web/models/contact';
import type {
  BulkActionCustomMergeContacts,
  BulkActionType
} from 'donor-elf-web/models/bulk-action';
import FormUnderlineLabel from 'donor-elf-web/components/form/underline/label';
import FormUnderlineSelect from 'donor-elf-web/components/form/underline/select';
import BulkActionSave from 'donor-elf-web/components/bulk-action/save';
import AlertInfo from 'donor-elf-web/components/alert/info';

interface ComponentArgs {
  contactToKeep: ContactModel;
  contactToMerge: ContactModel;
  changeset: any;
  onCompleted: () => void;
  onError: () => void;
}

export default class AddSomethingModalMergeContactsMergingComponent extends Component<ComponentArgs> {
  constructor(owner: unknown, args: ComponentArgs) {
    super(owner, args);
    setTimeout(() => {
      args.changeset.execute();

      const underscorePropertyNameEntries = Object.entries(args.changeset.data).map(([k, v]) => [underscore(k), v])
      const {
        add_name_to_tasks,
        add_name_to_pledges,
        ...attributes
      } = Object.fromEntries(underscorePropertyNameEntries);

      this.bulkActionCustom = {
        contact_id_to_keep: this.args.contactToKeep.id,
        contact_id_to_merge: this.args.contactToMerge.id,
        attributes,
        add_name_to_tasks,
        add_name_to_pledges,
      }
    })
  }

  bulkActionType: BulkActionType = 'merge_contacts';
  @tracked bulkActionCustom?: BulkActionCustomMergeContacts;
  @tracked merging = true;
  @tracked saveError = false;

  onCompleted = () => {
    this.merging = false;
    this.args.onCompleted();
  };

  onError = () => {
    this.merging = false;
    this.saveError = true;
    this.args.onError();
  };

  <template>
    <div>
      {{#if this.bulkActionCustom}}
        <BulkActionSave
          @bulkActionType={{this.bulkActionType}}
          @bulkActionCustom={{this.bulkActionCustom}}
          @onCompleted={{this.onCompleted}}
          @onError={{this.onError}}
        >
          <AlertInfo>
            Merging. This will take a few seconds...
          </AlertInfo>
        </BulkActionSave>
      {{/if}}
    </div>
  </template>
}
